import React from 'react';
import PropTypes from 'prop-types';
import { BASE_URL } from '../constants';
import './Splash.css';

const Splash = props => {
  const { setFirstVisit } = props;
  const inlineButtonStyles = {
    background: `url(${BASE_URL}/images/boton-entrar.png) 50% no-repeat`,
    backgroundSize: 'contain',
  };
  return (
    <div className='splash'>
      <img
        className='logo-inicio'
        src={`${BASE_URL}/images/logo-inicio.png`}
        alt='La Otra Isla Logo'
      />
      <p>
        LA OTRA ISLA es un archivo documental digital sobre arte actual en Cuba,
        narrado en voz de artistas y otros agentes relevantes en el contexto
        cultural de la isla, a partir de una serie de entrevistas realizadas en
        2019. Puedes navegar las distintas cápsulas documentales activando y
        desactivando los ejes temáticos que las agrupa: obra, contexto,
        formación, mercado y censura. Haz zoom al mapa para navegar con más
        facilidad. También puedes acceder a textos escritos para conocer más
        acerca de los diferentes agentes de esta escena de arte cubano.
      </p>
      <button
        className='boton-entrar'
        onClick={setFirstVisit}
        style={inlineButtonStyles}
        type='button'
      >
        &nbsp;
      </button>
    </div>
  );
};
export default Splash;
Splash.defaultProps = {
  setFirstVisit: () => {},
};
Splash.propTypes = {
  setFirstVisit: PropTypes.func,
};
